import { useContext } from "react";
import { UserContext } from "./user-context";

/**
 * The org the API will actually scope to: the explicitly selected one, or the
 * user's own org when nothing is selected (see `UserContextValue.activeOrg`).
 *
 * Tenant-scoped React Query keys must include this. Switching orgs remounts
 * the app, but the QueryClient is module-level and outlives that remount, so
 * an unscoped key would serve the previous org's data on the new mount.
 */
export const useEffectiveOrgId = (): number => {
  const { user, activeOrg } = useContext(UserContext);
  return activeOrg?.id ?? user.org.id;
};
